import * as React from 'react';

import ControlledNumericInput from 'ui-library/inputs/ControlledNumericInput';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import {DEGREE_SIGN, MELTING_TEMP_ABBREVIATION} from 'util/UnicodeSymbols';

interface BindingRegionMinMeltingTempProps {
  bindingRegionMinMeltingTemp: number | null;
  updateBindingRegionMinMeltingTemp: (bindingRegionMinMeltingTemp: number | null) => void;
  isDisabled: boolean;
}

/**
 * An input to set minimum binding region melting temperature in Golden Gate assembly.
 *
 * @param props Component props
 * @param {(number | null)} props.bindingRegionMinMeltingTemp The minimum melting temperature, in degrees Celsius, of the primer binding region.
 * @param {function} props.updateBindingRegionMinMeltingTemp A function that takes a new melting temperature and uses it to update state
 * @constructor
 */
export function BindingRegionMinMeltingTemp(props: BindingRegionMinMeltingTempProps): JSX.Element {
  return (
    <InputWrapper
      id="bindingRegionMinMeltingTemp"
      label={`Binding region - min. ${MELTING_TEMP_ABBREVIATION} (${DEGREE_SIGN}C)`}
      labelStyle={LabelStyle.LABEL}
      isRequired={true}
    >
      <ControlledNumericInput
        value={props.bindingRegionMinMeltingTemp}
        required={true}
        onChange={(e) => {
          props.updateBindingRegionMinMeltingTemp(e.target.numericValue);
        }}
        isDisabled={props.isDisabled}
      />
    </InputWrapper>
  );
}
